import { all } from 'redux-saga/effects';

import authSignUpSaga from './signUpSaga';
import authSignInSaga from './signInSaga';
import authRedirectsSaga from './authRedirectsSaga';
import authResetPasswordSaga from './resetPasswordSaga';
import globalFormErrorsSaga from './globalFormErrorsSaga';

export default function* authSaga() {
  return yield all([
    authSignUpSaga(),
    authSignInSaga(),
    authRedirectsSaga(),
    authResetPasswordSaga(),
    globalFormErrorsSaga(),
  ]);
}



// WEBPACK FOOTER //
// ./src/containers/Auth/saga/index.ts